<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>

    <v-app-bar app color="primary">
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">{{appNameFirst}} </span>
        <span class="font-weight-medium">{{appNameSecond}}</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid class="fill-height d-flex justify-space-around">
        <div class="text-center">
        <h1><v-icon large class="error--text">mdi-alert-circle</v-icon> Your account has been locked!</h1>
        <h1>Please contact your group administrator to resolve this issue.</h1>
<p>



        <router-link to="/">Click Here</router-link> to return to the application.
</p>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data:function(){
    return {
      appNameFirst: process.env.MIX_APPNAME_FIRST,
      appNameSecond: process.env.MIX_APPNAME_SECOND,
    };
  }
};
</script>
